import { SVGProps } from 'react';

export default function StoreIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <g clipPath="url(#clip0_5524_13964)">
        <path
          d="M3.68347 26.4427V10.3117M25.7316 10.6666V26.4427M10.2733 5.66016H5.8801V8.12416C5.8801 9.33226 6.8595 10.3117 8.0676 10.3117H8.08582C9.29392 10.3117 10.2733 9.33226 10.2733 8.12416M10.2733 5.66016V8.12416M10.2733 5.66016H14.6665M10.2733 8.12416C10.2733 9.33226 11.2527 10.3117 12.4608 10.3117H12.479C13.6871 10.3117 14.6665 9.33226 14.6665 8.12416M14.6665 5.66016V8.12416M14.6665 5.66016H19.0597V8.12416C19.0597 9.33226 18.0804 10.3117 16.8722 10.3117H16.854C15.6459 10.3117 14.6665 9.33226 14.6665 8.12416M21.2655 10.3117H21.2473C20.0392 10.3117 19.0598 9.33226 19.0598 8.12416V5.66016H23.453V8.12416C23.453 9.33226 22.4736 10.3117 21.2655 10.3117Z"
          stroke="black"
          strokeWidth="1.64062"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.651 5.66101H5.88015V8.12501C5.88015 9.33311 4.90075 10.3125 3.69265 10.3125H3.67444C2.46634 10.3125 1.48694 9.33311 1.48694 8.12501V5.66101L3.81663 1.55469H25.5166L27.8463 5.66101V8.12501C27.8463 9.33311 26.8669 10.3125 25.6588 10.3125H25.6406C24.4325 10.3125 23.4531 9.33311 23.4531 8.12501V5.66101H27.6276M27.8463 26.4435H1.48694M17.2607 13.8494H22.4267V21.3477H17.2607V13.8494ZM13.2246 26.4435L13.2377 13.8494H6.97795L6.96482 26.4435H13.2246Z"
          stroke="black"
          strokeWidth="1.64062"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5524_13964">
          <rect width="28" height="28" fill="white" transform="translate(0.666626)" />
        </clipPath>
      </defs>
    </svg>
  );
}
